__turbopack_context__.v({
  "heading": "legend-module-scss-module__5cGSyG__heading",
  "legend": "legend-module-scss-module__5cGSyG__legend",
  "sublegend": "legend-module-scss-module__5cGSyG__sublegend",
});
